import { createRouter, createWebHistory } from 'vue-router'
import i18n from '../i18n'
const routes = [
  {
    path: '/',
    name: 'home',
    meta: {
      layout: 'main',
      titleKey: 'title.home',
      descKey: 'description',
      title: 'LIVE RUSSIA - Играй в Россию на своём телефоне',
      desciption: 'Начни играть в Россию на своем телефоне',
      header: 'homeHeader'
    },
    component: () => import('../views/HomeView.vue')
  },
  {
    path: '/play',
    name: 'play',
    meta: {
      layout: 'main',
      titleKey: 'title.play',
      descKey: 'description',
      title: 'LIVE RUSSIA - Как начать играть',
      desciption: 'Начни играть в Россию на своем телефоне',
      header: 'header'
    },
    component: () => import('../views/HowToStartView.vue')
  },
  {
    path: '/donate',
    name: 'donate',
    meta: {
      layout: 'main',
      titleKey: 'title.donate',
      descKey: 'description',
      title: 'LIVE RUSSIA - Пополнить счет',
      desciption: 'Начни играть в Россию на своем телефоне',
      header: 'header'
    },
    component: () => import('../views/DonateView.vue')
  },
  {
    path: '/recovery',
    name: 'recovery',
    meta: {
      layout: 'main',
      titleKey: 'title.recovery',
      descKey: 'description',
      title: 'LIVE RUSSIA - Восстановить аккаунт',
      desciption: 'Начни играть в Россию на своем телефоне',
      header: 'header'
    },
    component: () => import('../views/RecoveryAccount.vue')
  },
  {
    path: '/agreement',
    name: 'agreement',
    meta: {
      layout: 'main',
      titleKey: 'title.agreement',
      descKey: 'description',
      title: 'LIVE RUSSIA - Договор оферты',
      desciption: 'Начни играть в Россию на своем телефоне',
      header: 'header'
    },
    component: () => import('../views/AgreementView.vue')
  },
  {
    path: '/privacy',
    name: 'privacy',
    meta: {
      layout: 'main',
      titleKey: 'title.privacy',
      descKey: 'description',
      title: 'LIVE RUSSIA - Политика конфиденциальности',
      desciption: 'Начни играть в Россию на своем телефоне',
      header: 'header'
    },
    component: () => import('../views/PrivacyView.vue')
  },
  {
    path: '/account-deletion',
    name: 'account-deletion',
    meta: {
      layout: 'main',
      titleKey: 'account_deletion.page_title',
      header: 'header'
    },
    component: () => import('../views/AccountDeletionView.vue')
  },
  {
    path: '/contacts',
    name: 'contacts',
    meta: {
      layout: 'main',
      titleKey: 'title.contacts',
      descKey: 'description',
      title: 'LIVE RUSSIA - Контакты',
      desciption: 'Начни играть в Россию на своем телефоне',
      header: 'header'
    },
    component: () => import('../views/ContactView.vue')
  },
  {
    path: '/success',
    name: 'success',
    meta: {
      layout: 'main',
      titleKey: 'title.payment',
      descKey: 'description',
      title: 'LIVE RUSSIA - Успешна оплата',
      desciption: 'Начни играть в Россию на своем телефоне',
      header: 'header'
    },
    component: () => import('../views/SuccessView.vue')
  },
  {
    path: '/:pathMatch(.*)*',
    name: 'not-found',
    meta: {
      layout: 'empty',
      titleKey: 'title.not_found'
    },
    component: () => import('../views/404View.vue')
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
  scrollBehavior () {
    return { top: 0, left: 0, behavior: 'auto' }
  }
})

router.beforeEach((to, from, next) => {
  const { t } = i18n.global
  if (to.meta.titleKey) {
    document.title = t(to.meta.titleKey)
  } else if (to.params.pathMatch) {
    const Capitalize = word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()
    document.title = Capitalize(to.params.pathMatch[0])
  }
  next()
})

export default router
